// Connecting the business's own domain on the Website page: what a refusal or a DNS warning from
// POST /site/domain means, in words the owner can act on. The keys are the codes of DomainError and
// DomainWarning (src/sites/domains.ts); test/site-domains.test.ts holds the two to each other.
// Everything here is English, translated where it is rendered, as in booking-moves.js.

export const DOMAIN_ERRORS = {
  not_available: "Connecting your own domain isn't available yet.",
  bad_domain: "Enter a domain like www.your-business.co.il",
  our_domain: "That address is already one of ours; use your own domain.",
  domain_taken: "That address is already connected to another website, so it can't be connected here.",
  cloudflare_refused: "Cloudflare refused this address, and trying again won't change that. Cloudflare's reason: {detail}",
  platform_unavailable: "We couldn't connect the domain because of a problem on our side. We've logged it; try again later or contact us.",
  domain_provider_error: "Cloudflare didn't answer just now. Nothing changed; try again in a minute.",
};

export const DOMAIN_ERROR_FALLBACK = "The domain couldn't be connected. Nothing changed.";

/** Added after an error that a different address on the same domain avoids. */
export const DOMAIN_SUGGESTION = "To keep what that address does today, connect a sub-address instead, for example {suggestion}.";

export const DOMAIN_WARNINGS = {
  points_elsewhere: "{host} already points to {current}. Once you change its record, whatever it shows today stops. To keep it, connect a sub-address instead, for example {suggestion}.",
  has_email: "{domain} receives email. Change only the one record for {host}: don't move the nameservers and don't delete other records, or the email stops.",
};

/** A point_elsewhere warning without a suggestion (the host is already a book. address). */
export const POINTS_ELSEWHERE_NO_SUGGESTION = "{host} already points to {current}. Once you change its record, whatever it shows today stops.";

/**
 * The owner's message for a failed connect: [text, vars] to pass to tr(). Cloudflare's own reason and
 * the suggested sub-address ride in error.detail and error.suggestion (ApiError carries them as data).
 */
export function domainErrorText(err) {
  const text = DOMAIN_ERRORS[err?.code];
  if (!text) return [[DOMAIN_ERROR_FALLBACK, {}]];
  const lines = [[text, { detail: err.data?.detail ?? "" }]];
  if (err.data?.suggestion && (err.code === "domain_taken" || err.code === "cloudflare_refused")) {
    lines.push([DOMAIN_SUGGESTION, { suggestion: err.data.suggestion }]);
  }
  return lines;
}

/** Each warning as [text, vars] for tr(). */
export function domainWarningTexts(host, warnings = []) {
  return warnings
    .map((w) => {
      if (w.code === "points_elsewhere") {
        return [w.suggestion ? DOMAIN_WARNINGS.points_elsewhere : POINTS_ELSEWHERE_NO_SUGGESTION, { host, current: w.current ?? "", suggestion: w.suggestion ?? "" }];
      }
      if (w.code === "has_email") return [DOMAIN_WARNINGS.has_email, { host, domain: w.domain ?? "" }];
      return null;
    })
    .filter(Boolean);
}
